export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="container">
        <div className="footer-inner">
          <p className="footer-copy">
            © {year} Yassine ALAOUI — Ingénieur Développeur Web
          </p>
          <div className="footer-links">
            <a href="https://www.linkedin.com/in/yassine-alaoui-0a42a9243/" target="_blank" rel="noreferrer">LinkedIn</a>
            <a href="https://github.com/Yassine-ALAOUI-a11" target="_blank" rel="noreferrer">GitHub</a>
            <a href="#contact">Email</a>
            <a href="#hero">↑ Haut</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
